import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { ImageUrls } from "../../../services/s3buket";
import { JobApplyService } from "../../job-apply/service/job-apply.service";
import { ActivatedRoute } from "@angular/router";
import { UserDetailsService } from "src/app/services/user/user-details.service";

@Component({
  selector: "app-search-applied-save-jobs-list",
  templateUrl: "./search-applied-save-jobs-list.component.html",
  styleUrls: ["./search-applied-save-jobs-list.component.css"]
})
export class SearchAppliedSaveJobsListComponent implements OnInit{
  @Input() job: any;
  status:any;
  id:any;
  @Output() onJobSaved = new EventEmitter<any>();
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  userDetails;
  showApplied:boolean = false
  showSaved:boolean = false
  constructor(private api: AdminService, private jobApplyService: JobApplyService, private userDetailsService: UserDetailsService) {
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDetails = userData;
    });
   }

  ngOnInit(): void {
    if(this.job._source?.isApplied != null){
      this.job._source?.isApplied.map((status)=>{
        if(status.companyId == this.userDetails.id){
          this.showApplied = true;
        }
      })
    }
    if(this.job._source?.saveStatus != null){
      this.job._source?.saveStatus.map((status)=>{
        if(status.companyId == this.userDetails.id){
          this.showSaved = true;
        }
      })
    }

    this.jobApplyService.onJobAppliedStatusChange.subscribe((jobApplied)=> {
      this.showApplied = jobApplied;
    })
  } 
  applyJob(job) {
    let recruiterID =this.job._source?.recuiterId
    this.jobApplyService.applyJob(this.job._source, recruiterID );
  }

  withdrawJob(job) { 
    // this.job=job._source.id
    this.jobApplyService.withdrawJob(this.job._source.id);
  }

  saveUnsaveJob(job) { 
    // this.job=job._source.id
    if (!this.showSaved) {
      this.api.postData(apiUrl._saveUnsaveJob, {"jobPostId": this.job._source.id}).subscribe((x) => {
        this.showSaved = true;
        this.onJobSaved.emit(this.job);
      });
    } else {
      this.api.deleteData(apiUrl._saveUnsaveJob, {"jobPostId":  this.job._source.id}).subscribe((x) => {
        this.showSaved = false;
        this.onJobSaved.emit(this.job);
      });
    }
  }
  jobSalaryFilter(job: any): string {
    let salary = "";
    if (job?._source?.price) salary = job?._source?.price;
    else if (job?._source?.maxSalary && !job?._source?.minSalary) salary =  job?._source?.maxSalary;
    else if (job?._source?.minSalary && !job?._source?.maxSalary) salary =  job?._source?.minSalary;
    else if (job?._source?.maxSalary && job?._source?.minSalary) salary = job?._source?.minSalary + "-$" + job?._source?.maxSalary;
    else salary = job?._source?.minSalary + job?._source?.maxSalary;
    if (job?._source?.rate) return "$" + salary + "/" + job?._source?.rate.split(" ")[1];
    else return "$" + salary;
  }

  dateInMilisecond(date) {
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }
}
